var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_2086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6937 4.15681C21.6937 4.15681 21.6937 4.16619 21.6937 4.17088L16.2374 22.1653C16.1548 22.4575 15.9848 22.7175 15.7502 22.9104C15.5156 23.1033 15.2276 23.2198 14.9249 23.2443C14.8818 23.2481 14.8387 23.2499 14.7955 23.2499C14.5119 23.2508 14.2338 23.1705 13.9943 23.0185C13.7548 22.8665 13.5637 22.6492 13.4437 22.3921L10.0312 15.389C9.99703 15.3188 9.98563 15.2397 9.99857 15.1628C10.0115 15.0858 10.0481 15.0148 10.1034 14.9596L15.5334 9.52963C15.6681 9.38783 15.7421 9.19902 15.7396 9.00345C15.7371 8.80787 15.6583 8.62102 15.52 8.48272C15.3817 8.34442 15.1948 8.26561 14.9992 8.26311C14.8037 8.2606 14.6148 8.3346 14.473 8.46931L9.04024 13.8993C8.98508 13.9545 8.91407 13.9912 8.8371 14.0041C8.76013 14.017 8.68104 14.0056 8.61086 13.9715L1.60117 10.5599C1.32707 10.4284 1.09939 10.2167 0.948314 9.95292C0.797238 9.68909 0.729895 9.38559 0.75521 9.08263C0.780525 8.77966 0.897302 8.49154 1.09007 8.25645C1.28283 8.02135 1.54248 7.85038 1.83461 7.76619L19.829 2.30994H19.843C20.0993 2.23796 20.37 2.23544 20.6275 2.30263C20.885 2.36982 21.12 2.50431 21.3083 2.69229C21.4967 2.88028 21.6317 3.11499 21.6994 3.37236C21.7671 3.62972 21.7651 3.90047 21.6937 4.15681Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_2086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.5f3f2c8c1cbee9bbf95fa629634f65f2.svg";
export { ForwardRef as ReactComponent };